


















































































































































































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import CompaniesSwitcher from "@/components/CompaniesSwitcher.vue";
import CategoryPathsViewer from "@/components/CategoryPathsViewer.vue";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";
dayjs.extend(duration);
dayjs.extend(relativeTime);

@Component({
  components: {
    CompaniesSwitcher,
    CategoryPathsViewer,
  },
})
export default class BulkJobList extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private companyId!: string;
  @Prop() private accountId!: string;
  @Prop({ default: () => 1 }) private page!: number;

  private pageNumber = this.page;
  private jobsList = [];
  private loading = true;
  private paginationRowsPerPage = 20;
  private paginationTotalRecords = 0;
  private currentSortField = "createdAt";
  private sortTypeASC = false;
  private jobNameField = "metadata->>'jobName'";
  private errorMessage = "";

  private stepsByRoles = {
    customerOrRepWithSupport: [
      "Upload product catalog",
      "Fill Questionare",
      "Review and create",
    ],
    customerOrRepWithoutSupport: [
      "Upload product catalog",
      "Fill Questionare",
      "Map columns",
      "Select profile/categories",
      "Review and create",
    ],
    expert: [
      "Upload product catalog",
      "Fill Questionare",
      "Upload curated catalog",
      "Map columns",
      "Select profile/categories",
      "Review and create",
    ],
  };

  mounted() {
    this.populateJobsList();
  }

  @Watch("currentSortField")
  @Watch("sortTypeASC")
  @Watch("companyId")
  async populateJobsList() {
    this.loading = true;
    this.$store.commit("startLoading");
    try {
      const skip = this.paginationStartIndex();
      const top = this.paginationRowsPerPage;
      const orderBy =
        this.currentSortField + (this.sortTypeASC ? " ASC" : " DESC");
      const jobsListResponse = await this.$api.get(
        `item-classification-api/v1/jobs/${this.companyId}?skip=${skip}&top=${top}&orderBy=${orderBy}`
      );
      this.paginationTotalRecords = jobsListResponse.data.recordsetCount;
      this.jobsList = jobsListResponse.data.value;
      this.$store.commit("stopLoading");
      this.loading = false;
    } catch (error) {
      const errorCode = error.response.data.code;
      if (_.has(errorsUtil.errorMessages, errorCode)) {
        this.$store.commit("recordError", "");
        this.errorMessage = errorsUtil.errorMessages[errorCode];
      }
      this.$store.commit("stopLoading");
      this.loading = false;
    }
  }

  private paginationStartIndex() {
    return (this.pageNumber - 1) * this.paginationRowsPerPage;
  }

  private onPageChange(e: any) {
    const hasPageChanged =
      e.detail.currentPage !== 0 && e.detail.currentPage !== this.pageNumber;
    const hasRowsPerPageChanged =
      e.detail.rowsPerPage !== this.paginationRowsPerPage;
    if (hasPageChanged) {
      this.pageNumber = e.detail.currentPage;
      const query = Object.assign({}, this.$route.query);
      query.page = e.detail.currentPage;
      this.$router.push({ query });
    }
    this.paginationRowsPerPage = e.detail.rowsPerPage;
    if (hasPageChanged || hasRowsPerPageChanged) this.populateJobsList();
  }

  jobStatus(job) {
    return this.$_.isEmpty(job.status)
      ? "CREATED"
      : job.status === "STARTED"
      ? "PROCESSING"
      : job.status;
  }

  getSteps(jobDetails) {
    if (this.$store.state.herculeRole === "ClassificationInternalExpert") {
      return this.stepsByRoles["expert"];
    } else {
      const isFullClassificationAdmin =
        this.$store.state.herculeRole === "ClassificationAdmin" &&
        this.$store.getters.featureLevel("item-classification") === "full";
      if (isFullClassificationAdmin) {
        return jobDetails.metadata.support &&
          jobDetails.metadata.support == "true"
          ? this.stepsByRoles["customerOrRepWithSupport"]
          : this.stepsByRoles["customerOrRepWithoutSupport"];
      } else {
        return this.stepsByRoles["customerOrRepWithSupport"];
      }
    }
  }

  jobLink(job) {
    const categoryStepCompleted = job.categories && job.categories.length > 0;
    const fieldMappingStepCompleted =
      job.metadata.field_mapping_source &&
      job.metadata.field_mapping_source === "user" &&
      Object.keys(job.fieldMapping).length > 0;
    const curatedUploadStepCompleted = "curatedFileName" in job.metadata;
    const questionareStepCompleted = job.metadata.isQuestionnaireDone == "true";
    const uploadStepCompleted =
      job.metadata.fileName && job.metadata.fileName !== "";
    const steps = this.getSteps(job);
    const conditionByStepName = {
      "Upload product catalog": uploadStepCompleted,
      "Fill Questionare": questionareStepCompleted,
      "Upload curated catalog": curatedUploadStepCompleted,
      "Map columns": fieldMappingStepCompleted,
      "Select profile/categories": categoryStepCompleted,
      "Review and create": false,
    };
    let step = 0;
    for (step = 0; step <= steps.length - 1; step++) {
      const stepName = steps[step];
      if (!conditionByStepName[stepName]) break;
    }

    return {
      name: "bulk_job",
      params: {
        accountId: this.accountId,
        companyId: this.companyId,
      },
      query: {
        jobId: job.jobId,
        step,
      },
    };
  }

  jobTags(job) {
    return job.tags.map((tag) =>
      tag.length > 20 ? (tag as string).substring(0, 18) + "..." : tag
    );
  }

  jobName(job) {
    return job.metadata.jobName
      ? job.metadata.jobName
          .split(" ")
          .map((word) =>
            word.length > 40 ? (word as string).substring(0, 37) + "..." : word
          )
          .join(" ")
      : "";
  }

  jobUser(job) {
    return job.userName.length > 35
      ? job.userName.substring(0, 33) + "..."
      : job.userName;
  }

  async downloadOutput(job) {
    try {
      this.$store.commit("startLoading");
      const downloadLocation =
        job.status !== "PENDING REVIEW" ? "output" : "classificationoutput";
      const downloadResponse = await this.$api.get(
        `item-classification-api/v1/jobs/${this.companyId}/${job.jobId}/${downloadLocation}`,
        {
          params: {},
          responseType: "arraybuffer",
          headers: {
            Accept: "application/octet-stream",
          },
        }
      );
      const url = window.URL.createObjectURL(new Blob([downloadResponse.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "output.csv");
      document.body.appendChild(link);
      link.click();
      this.$store.commit("stopLoading");
    } catch (error) {
      const errorCode = error.response.data.code;
      if (_.has(errorsUtil.errorMessages, errorCode)) {
        this.$store.commit("recordError", "");
        this.errorMessage = errorsUtil.errorMessages[errorCode];
      }
      this.$store.commit("stopLoading");
    }
  }

  private formatDate(date) {
    return dayjs(date).format("YYYY/MM/DD");
  }

  isNewJobAllowed() {
    return (
      this.$store.getters.featureLevel("item-classification") !== "disabled"
    );
  }

  jobProgress(job) {
    return 100 * (job.processedRecords / job.totalRecords);
  }

  companyName(id) {
    return this.$store.getters.companyName(id);
  }

  async companySwitched(event) {
    const params = Object.assign({}, this.$route.params, {
      companyId: event.companyId,
    });

    this.$router.push({ name: "bulk_job_list", params: params });
  }

  onSortChange(field) {
    if (this.currentSortField === field) this.sortTypeASC = !this.sortTypeASC;
    else {
      this.currentSortField = field;
      this.sortTypeASC = false;
    }
  }

  sortIconType(field) {
    if (this.currentSortField === field)
      return this.sortTypeASC ? "arrow-up" : "arrow-down";
    return "arrow-down";
  }
}
